export enum CustomerDispatchStrategy {
    ProfitOptimization = 'PROFIT_OPTIMIZATION',
    PreferredFirst = 'PREFERRED_FIRST',
}